import { BILLING_ROUTE } from "../../routes";

const getCurrentLoadedBilling = (state, clubId) => {
  if (!clubId) return null;

  const normalizedClubId = String(clubId);

  if (
    state?.clubId === normalizedClubId &&
    state?.loaded === true &&
    !state?.error &&
    String(state?.billing?.clubId) === normalizedClubId
  ) {
    return state.billing;
  }

  return null;
};

export const hasConfirmedInactiveBillingAccess = (state, clubId) => {
  const billing = getCurrentLoadedBilling(state, clubId);

  return (
    billing?.billingEnabled !== false &&
    billing?.billingAccessMode === "inactive"
  );
};

export const shouldRestrictClubToBilling = (state, clubId, isUserSuperAdmin) =>
  !isUserSuperAdmin && hasConfirmedInactiveBillingAccess(state, clubId);

export const hasConfirmedDisabledBillingRollout = (state, clubId) => {
  const billing = getCurrentLoadedBilling(state, clubId);

  return billing?.billingEnabled === false;
};

export const shouldRedirectDisabledBillingRoute = (
  state,
  clubId,
  isUserSuperAdmin
) =>
  !isUserSuperAdmin && hasConfirmedDisabledBillingRollout(state, clubId);

export const shouldShowNavigationItemForBillingAccess = (
  item,
  restrictToBilling
) => !restrictToBilling || item?.path === BILLING_ROUTE;
